<template>
    <div class="FM_withdrawalInfo">
        <!-- 提现详情/审核 -->
        <el-dialog
            ref="terminalAudit"
            :visible="infoIsShow"
            @close="handleClose"
            :close-on-click-modal="false"
        >
            <el-card class="box-card" shadow="hover">
                <div class="title">银行信息</div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <span class="labels">持卡人姓名：</span>
                        <span>{{dialogData.data.cardholder_name}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">银行名称：</span>
                        <span>{{dialogData.data.bank_name}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">银行卡号：</span>
                        <span>{{dialogData.data.bank_code}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">预留手机号：</span>
                        <span>{{dialogData.data.phone}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">开户所在地：</span>
                        <span>{{dialogData.data.bank_prov}}-{{dialogData.data.bank_city}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">开户支行：</span>
                        <span>{{dialogData.data.branch_bank}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">联行号：</span>
                        <span>{{dialogData.data.line_num}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">提现金额：</span>
                        <span>{{dialogData.data.money}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">代收税点：</span>
                        <span>{{dialogData.data.fee_money}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">预扣个税：</span>
                        <span>{{dialogData.data.user_personal_tax}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">预扣增值税：</span>
                        <span>{{dialogData.data.user_value_added_tax}}</span>
                    </el-col>
                    <el-col :span="24">
                        <span class="labels">预扣附加税：</span>
                        <span>{{dialogData.data.user_additional_tax}}</span>
                    </el-col>
                    <el-col :span="24" v-show="dialogData.data.service_fee != 0">
                        <span class="labels">出款服务费：</span>
                        <span>{{dialogData.data.service_fee}}</span>
                    </el-col>
                    <!-- ----- -->
                    <el-col :span="24" v-if="dialogData.isInfo!=2">
                        <span class="labels">结算金额：</span>
                        <span>{{dialogData.data.true_money}}</span>
                    </el-col>
                    <el-col :span="24" v-if="dialogData.isInfo!=2">
                        <span class="labels">提现后余额：</span>
                        <span>{{dialogData.data.zo}}</span>
                    </el-col>
                    <el-col :span="24" v-if="dialogData.isInfo!=2">
                        <span class="labels">分润账户余额：</span>
                        <span>{{dialogData.data.zero}}</span>
                    </el-col>
                    <el-col :span="24" v-if="dialogData.isInfo!=2">
                        <span class="labels">活动账户余额：</span>
                        <span>{{dialogData.data.one}}</span>
                    </el-col>
					<el-col :span="24" v-if="dialogData.isInfo!=2">
					    <span class="labels">押金账户余额：</span>
					    <span>{{dialogData.data.two}}</span>
					</el-col>
                    <el-col :span="24">
                        <span class="labels">申请时间：</span>
                        <span>{{dialogData.data.create_time}}</span>
                    </el-col>
                    <el-col :span="24" v-show="dialogData.data.status == 5">
                        <span class="labels">失败原因：</span>
                        <br />
                        <div v-html="dialogData.data.directions" class="desc"></div>
                    </el-col>
                    <el-col :span="24" v-if="dialogData.isInfo!=2">
                        <span class="labels">审核状态：</span>
                        <span>{{status}}</span>
                    </el-col>
                    <el-col :span="24" v-if="dialogData.isInfo!=2">
                        <span class="labels">结算方式：</span>
                        <span>{{payType}}</span>
                    </el-col>
                </el-row>
                
                <el-form
                    :model="auditForm"
                     size="mini"
                    v-if="dialogData.isInfo != 1"
                >
                   <el-form-item v-if="pay_channel == 3" style="display: flex; align-items: center;justify-content: flex-start;padding: 0px;color: #000;" label="选择签约服务商：">
                   	  <el-select @change="selChange"  v-model="auditForm.service_company_id" clearable>
                   	  	<el-option v-for="item in channelList" :label="item.service_company_name" :value="item.service_company_id"
                   	  		:key="item.service_company_name"></el-option>
                   	  </el-select>
                   </el-form-item>
                    <div class="audit">
                        <div class="title">审核</div>
                        <el-form-item  label-width="0px">
                            <el-radio v-model="auditForm.auditRadio" :label="1">通过</el-radio>
                            <el-radio v-model="auditForm.auditRadio" :label="2">拒绝</el-radio>
                        </el-form-item>
                        <span style="color:red" v-if="auditForm.auditRadio == 2">注：拒绝后，提现金额将原路退回</span>
                    </div>
<!--                    <div class="audit" v-if="auditForm.auditRadio != 2">
                        <div class="title">结算方式</div> -->
                        <!--<el-form-item>
                        //    <el-radio
                        //        v-if="dialogData.data.isShowPayMethods"
                        //        v-model="auditForm.type"
                        //        :label="1"
                        //        @change="typeChange"
                        //    >平台代付</el-radio>
                        //    <el-radio v-model="auditForm.type" :label="2" @change="typeChange">线下付款</el-radio>
                        </el-form-item>-->
                            <!-- <el-radio  :disabled="dialogData.data.wat == 1" v-model="auditForm.auditRadio1" :label="0" @change="typeChange">分润账户(0)[余额:¥{{balance.payment_balance0}}]</el-radio>
                            <el-radio  :disabled="dialogData.data.wat == 0" v-model="auditForm.auditRadio1" :label="1" @change="typeChange">基本账户(1)[余额:¥{{balance.payment_balance1}}]</el-radio> -->

<!--                            <el-radio  v-model="auditForm.auditRadio1" :label="0" @change="typeChange">分润账户(0)[余额:¥{{balance.payment_balance0}}]</el-radio>
                            <el-radio  v-model="auditForm.auditRadio1" :label="1" @change="typeChange">基本账户(1)[余额:¥{{balance.payment_balance1}}]</el-radio>
                    </div> -->
                </el-form>
                <div style="margin-top:20px" v-if="dialogData.isInfo != 1">
                    <el-button
                        @click="submit"
                        type="primary"
                        size="medium"
                        style="font-size:12px"
                        :loading="loading"
                    >确 定</el-button>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "FM_withdrawalInfo",
    props: {
        infoIsShow: {
            type: Boolean,
            default: false
        },
        dialogData: {
            type: Object
        }
    },
    data() {
        return {
            balance: {},//账户余额
            auditForm: {
                auditRadio: 1,
                // auditRadio1: this.dialogData.data.wat,
                type: 0,
                service_company_id:'',
                contract_code:''
                
            },
            // resData: {},
            loading: false,
            channelList:[],
            pay_channel:1
        }
    },
    mounted() {
        // let bankId = this.dialogData.data.bank_id;
        // this.$api.post('user/bank_info', { bank_id: bankId }, res => { //初始化
        //     if (res.code == 0) {
        //         this.resData = res.data[0];
        //     } else {
        //         this.$message.error(res.msg);
        //     }
        // })
        // this.$api.post('organization/getBalance', {}, res => {
        //         if (res.code == 0) {
        //             this.balance = res.data;
        //             let timer = null;
        //             timer = setInterval(() => { //防止刷新时多次点击
        //                 this.refLoading = false;
        //                 clearInterval(timer);
        //             }, 1000);
        //         } else {
        //             this.$message.error(res.msg);
        //             this.refLoading = false;
        //         }
        //     });
        
        this.$api.post('user/withdraw_list', {}, res => {
            if (res.code == 0) {
                
               this.channelList = res.data.contract_list
               
                this.pay_channel =  res.data.pay_channel

            } else {
                this.$message.error(res.msg);
             
            }
        });
        
    },
    methods: {
        
        selChange(e) {
            for (let item of this.channelList) {
                if (item.service_company_id == e) {
                    this.auditForm.contract_code = item.contract_code
                }
            }
        },
        
        submit() { //提交
            var payType = 0;
            let { id, user_id } = this.dialogData.data;
            if (this.auditForm.auditRadio == 2) {
                payType = 3;
            } else {
                payType = this.auditForm.auditRadio;
            }
            
            if (this.pay_channel == 3 && this.auditForm.service_company_id.length == 0) {
                this.$message.error({
                    type: 'error',
                    message: '请选择签约服务商!',
                    duration: 2000,
                });
                
                return
            }
            this.loading = true; //防重复
            this.$api.post('user/withdraw_audit', { type: payType, id, user_id ,balance:this.balance,pay_channel:this.pay_channel, contract_code: this.auditForm.contract_code,service_company_id: this.auditForm.service_company_id}, res => {
                if (res.code == 0) {
                    let that = this;
                    this.$message.success({
                        type: 'success',
                        message: res.msg,
                        duration: 2000,
                        onClose() {
                            that.handleClose(1);
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                    this.loading = false;
                }
            });
        },
        typeChange(val) { //监听radio
            this.auditForm.auditRadio1 = val;
        },
        handleClose(ref) {
            this.$emit('infoClose', ref);
        }
    },
    computed: {
        status() {
            var status = '';
            switch (this.dialogData.data.status) {
                case 0:
                    status = '未审核';
                    break;
                case 1:
                    status = '提现成功';
                    break;
                case 2:
                    status = '审核拒绝';
                    break;
                case 3:
                case 4:
                    status = '等待结果';
                    break;
                default:
                    status = '提现失败';
                    break;
            }
            return status;
        },
        payType() {
            var payType = '';
            switch (this.dialogData.data.start_account_type) {
                case 0:
                    payType = '分润账户';
                    break;
                case 1:
                    payType = '活动账户';
                    break;
				case 2:
					payType = '押金账户';
					break;
                // case 0:
                //     payType = '- -';
                //     break;
                // case 1:
                //     payType = '线下支付';
                //     break;
                // case 2:
                //     payType = '微信支付';
                //     break;
                // case 3:
                //     payType = '支付宝支付';
                //     break;
                // default:
                //     payType = '平台支付';
                //     break;
            }
            return payType;
        }
    }
};
</script>

<style lang="scss" scope>
.FM_withdrawalInfo {
    * {
        font-size: 12px;
    }
    .labels {
        font-weight: 700;
    }
    .desc {
        border: 1px solid #d0d0d0;
        background-color: #ebeef5;
        padding: 3px;
        line-height: 20px;
        margin-top: 5px;
    }
    .title {
        margin: 0px 0;
        font-size: 13px;
        font-weight: 700;
        border-left: 5px solid #40b8ff;
        padding: 0 0 0 10px;
        .el-button--text {
            color: #303133;
            font-size: 13px;
            font-weight: 700;
        }
    }
    .el-input__inner,
    ::v-deep .el-radio__label {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
        ::v-deep .el-form-item__label {
            padding: 0;
            font-weight: 700;
            font-size: 12px;
        }
        ::v-deep .el-form-item__content {
            line-height: 0;
        }
    }
    ::v-deep .el-checkbox__label {
        font-size: 12px;
    }
    .el-row {
        margin: 10px 0;
        &:last-child {
            margin-bottom: 0;
        }
        .el-col {
            margin: 10px 0;
        }
    }
}
</style>
